import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdSubmissionValidateRequest } from './types';

/** Runs the create's own checks without filing, so a rejection lands while the advisor still has the form. */
export const useRegEdSubmissionValidateMutation = ({
	onError,
}: {
	onError: (error: Api.IOperationResultNoValue) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			request,
			impersonationContext,
		}: {
			request: IRegEdSubmissionValidateRequest;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/submissions/validate',
				}),
				'POST',
				request
			),
		onError,
	});
};
